/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Commons_Error_Page_Go_To_HelpInputs */

const de_commons_error_page_go_to_help = /** @type {(inputs: Commons_Error_Page_Go_To_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum Hilfebereich`)
};

/** @type {(inputs: Commons_Error_Page_Go_To_HelpInputs) => LocalizedString} */
const en_commons_error_page_go_to_help = de_commons_error_page_go_to_help;

/**

* @param {Commons_Error_Page_Go_To_HelpInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const commons_error_page_go_to_help = /** @type {((inputs?: Commons_Error_Page_Go_To_HelpInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Commons_Error_Page_Go_To_HelpInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_commons_error_page_go_to_help(inputs)
	return en_commons_error_page_go_to_help(inputs)
});